module.exports = __webpack_public_path__ + "/0c4e0f63aeb6496ec2c38a9facd585f6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/app/content/team/team_x_icon@2x.png
 ** module id = 851
 ** module chunks = 0
 **/